function OPDBilling({ embeddedInModal }) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center text-gray-500 ${
        embeddedInModal ? "py-16" : "min-h-[50vh]"
      }`}
    >
      <p className="text-sm font-medium text-[#217E90]">OPD Billing</p>
      <p className="mt-2 text-xs">Billing screen will be connected here.</p>
    </div>
  );
}

export default OPDBilling;
